/// <reference path="../app.ts" />

namespace Cfnc {
    "use strict"

    interface IProgramDetails {
    }

    class ProgramDetails implements IProgramDetails {
        static $inject: Array<string> = ["common", "Restangular", "$routeParams", "$q"];
        static controllerId: string = "programDetails";

        urlName: string;
        program: any;
        loading: boolean = true;
        schoolsOfferingProgram: any;
        programLength: any;
        pageNumber: any;
        log: (msg, data?, showToast?) => void;
        logError: (msg, data?, showToast?) => void;
        logSuccess: (msg, data?, showToast?) => void;

        constructor(private common: ICommonFactory, private Restangular: Restangular.IService, private $routeParams: ng.route.IRouteParamsService, private $q: ng.IQService) {
            this.log = common.logger.getLogFn(ProgramDetails.controllerId);
            this.logError = common.logger.getLogFn(ProgramDetails.controllerId, "error");
            this.logSuccess = common.logger.getLogFn(ProgramDetails.controllerId, "success");
            this.log = common.logger.getLogFn(ProgramDetails.controllerId);
            this.pageNumber = 1;
            this.urlName = $routeParams.program;
            this.activate();
        }

        activate() {
            var promises = [this.getProgram()];
            this.common.activateController(promises, ProgramDetails.controllerId)
                .then(() => {
                    this.loading = false;
                });
        }

        getProgram(): ng.IPromise<void> {
            return this.Restangular.all("programsMajors").all("programs").one(this.urlName).get()
                .then((result) => {
                    this.program = result;
                    this.getSchoolsAndPrograms();
                },
                    (reason) => {
                        this.logError(reason, reason, true);
                    });
        }

        getSchoolsAndPrograms(): ng.IPromise<void> {
            var queryParams = { pageNumber: this.pageNumber };
            return this.Restangular.all("programsMajors").all("programs").all("schoolsOfferingProgram").one(this.urlName).get(queryParams)
                .then((result) => {
                    this.schoolsOfferingProgram = result;
                    this.programLength = result.length;
                }, (reason) => {
                        this.logError(reason, reason, true);
                });
        }

        saveProgram(): ng.IPromise<void> {
            return this.Restangular.all("programsMajors").all("saveProgram").post(this.program)
                .then((result) => {
                    this.program.isSaved = !this.program.isSaved;
                    var message = this.program.isSaved ? 'Program saved successfully.' : 'Program removed successfully.';
                    this.logSuccess(message, '', true);
                },
                    (reason) => {
                        this.logError(reason, reason, true);
                    });
        }
    }
    angular.module("app").controller(ProgramDetails.controllerId, ProgramDetails);
} 